var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7711 3.00234C19.5384 1.66589 21.4616 1.66589 22.2289 3.00234L37.7309 30.0013C38.4967 31.335 37.5367 33 36.002 33H4.99799C3.46328 33 2.50329 31.335 3.26906 30.0013L18.7711 3.00234ZM18.5952 13.9838C18.546 12.9 19.4181 11.9944 20.5 11.9944C21.5819 11.9944 22.454 12.9 22.4048 13.9838L22.0642 21.4985C22.0262 22.337 21.3371 22.9973 20.5 22.9973C19.6629 22.9973 18.9738 22.337 18.9358 21.4985L18.5952 13.9838ZM20.5 24.9979C19.3982 24.9979 18.505 25.8935 18.505 26.9984C18.505 28.1033 19.3982 28.9989 20.5 28.9989C21.6018 28.9989 22.495 28.1033 22.495 26.9984C22.495 25.8935 21.6018 24.9979 20.5 24.9979Z",
    fill: "#364356"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/iconError.298daaa2.svg";
export { ForwardRef as ReactComponent };